module.exports = __webpack_public_path__ + "static/media/rounded-right-arrow-blue.0d6da948.svg";